module.exports = __webpack_public_path__ + "img/visabg-2.2b42c729.jpg";